
















import Vue from 'vue'
import { IDevice, IVW } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { deepCopy } from '@/utils'
import VwResizePreview from '@/components/VwResizePreview.vue'
import { VW_MAX_COLUMNS, VW_MAX_ROWS } from '@/vw_algorithm'
import { extender_vendor_t } from '@/types/api'

export default mixins(vwDialogMixin).extend({
  components: {
    VwResizePreview
  },
  data (): {
    vendor: extender_vendor_t,
    VENDOR_OPTIONS: Array<{key: extender_vendor_t, label: string}>
  } {
    return {
      vendor: 'Aspeed',
      VENDOR_OPTIONS: [
        {key: 'Aspeed', label: this.$t('model.hg') as string }, // TODO: keep DRY
        {key: 'Aptovision', label: this.$t('model.hx') as string }
      ]
    }
  },
  computed: {
    vw (): IVW | null { return this.dialog.vw }
  },
  methods: {
    async apply () {
      if (!this.vw) { return }
      const cpVw = deepCopy(this.vw)
      cpVw.vendor = this.vendor
      cpVw.rxList.length = 0
      const ok = await easyapi.modifyVw(cpVw)
      if (ok) {
        this.closeThisDialog()
      }
    }
  },
  watch: {
    vw (vw: IVW | null) {
      if (vw) { this.vendor = vw.vendor }
    }
  }
})
